import React from 'react';
import { PropTypes } from 'prop-types';
import {
  BarChart,
  Bar,
  XAxis,
  Tooltip,
  ResponsiveContainer,
  Cell
} from 'recharts';

import './bar.scss';

import { TYPES } from 'envs';
import CustomTooltip from './customTooltip';
import Logger from '../../utils/logger';
import { customAcronym, customColor, getSite } from '../../constants';

const CustomizedAxisTick = ({ x, y, payload }) => (
  <g transform={`translate(${x},${y})`}>
    <text
      x={0}
      y={0}
      dy={16}
      textAnchor="start"
      transform="rotate(20)"
      fill="#666"
      fontSize="11px"
    >
      {payload.value}
    </text>
  </g>
);

CustomizedAxisTick.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  payload: PropTypes.shape({})
};

const LABEL_OPTIONS = (label = '%') => ({
  position: 'top',
  content: props =>
    `${Number(Number(props.value).toFixed(2)).toLocaleString('es')}${label}`
});

const AtresBarChart = ({
  data: data1,
  seatTotal,
  type,
  visibles,
  dataKey = 'votesPerent',
  isSenate,
  labelAbrv,
  slice = 6
}) => {
  const unitAbrv = items => {
    const labelMunicipal = items > 1 ? 'concejales' : 'concejal';
    const labelAutonomic = items > 1 ? 'escaños' : 'escaño';
    const label = type === TYPES.MUNICIPAL ? labelMunicipal : labelAutonomic;

    if (isSenate) {
      if (items > 1) {
        return 'senadores';
      }
      return 'senador';
    }
    if (items > 1) {
      return `${label}`;
    }
    return label;
  };

  const totalInData = data1.reduce((tot, current) => {
    tot += current.seats;
    return tot;
  }, 0);
  const data =
    totalInData === seatTotal
      ? data1
      : data1.concat([
          {
            id: -1,
            name: 'Sin asignar',
            partyAcronym: 'Sin asignar',
            partyColor: '#ffffff',
            seats: seatTotal - totalInData,
            votes: 0,
            votesPercent: 0
          }
        ]);

  Logger.log('AtresBarChart', 'nuevo render', data.slice(0, 10), 'ChartData');

  let showData = JSON.parse(JSON.stringify(data));

  showData =
    dataKey === 'seats'
      ? showData
          .filter(current => current.seats >= 1)
          .slice(0, 10)
          .map(data => {
            return {
              ...data,
              partyAcronym: customAcronym(data, getSite())
            };
          })
      : showData
          .reduce((filtered, option) => {
            if (option.votesPercent > 0) {
              option.votesPercent = parseFloat(
                Number.parseFloat(option.votesPercent).toFixed(2)
              );
              filtered.push(option);
            }
            return filtered;
          }, [])
          .slice(0, slice)
          .map(data => {
            return {
              ...data,
              partyAcronym: customAcronym(data, getSite())
            };
          });

  return (
    <ResponsiveContainer minHeight="245px" height="60%" className="BarChart">
      <BarChart
        data={showData}
        margin={{ top: 15, right: 30, left: 20, bottom: 5 }}
      >
        <Tooltip
          content={<CustomTooltip unitName={unitAbrv} isSenate={isSenate} />}
        />
        <XAxis
          height={75}
          type="category"
          dataKey="partyAcronym"
          allowDataOverflow
          interval={0}
          tickMargin={-5}
          isAnimationActive={false}
          tick={<CustomizedAxisTick />}
        />
        <Bar
          dataKey={dataKey}
          fill="#8884d8"
          label={LABEL_OPTIONS(labelAbrv)}
          isAnimationActive={false}
        >
          {showData.map((entry, index, arr) => (
            <Cell
              key={`${customAcronym(entry, getSite())}_${entry.votes}`}
              fill={customColor(entry, getSite())}
              stroke={entry.id === -1 ? '#454545' : ''}
              strokeWidth={entry.id === -1 ? 1 : ''}
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default AtresBarChart;
